<div
  class="pnl-order"
  [class.open]="open"
  infiniteScroll
  [fromRoot]="true"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="20"
  [infiniteScrollContainer]="selector"
  (scrolled)="onScroll()"
>
  <header>
    <h1>Pedidos</h1>
    <button (click)="onExport()" type="button" class="btn btn-primary-outline">
      <i class="ic ic-export"></i> Exportar
    </button>
  </header>
  <section class="pnl">
    <ul class="tabs">
      <li
        (click)="changeTab('pendente')"
        class="pendente"
        [class.active]="tab == 'pendente'"
      >
        <a>
          <span>{{ num_pedente }}</span>
          <strong>Pendente</strong>
        </a>
      </li>
      <li
        (click)="changeTab('lente')"
        class="lente"
        [class.active]="tab == 'lente'"
      >
        <a>
          <span>{{ num_lente }}</span>
          <strong>Lente Solicitada</strong>
        </a>
      </li>
      <li
        (click)="changeTab('separacao')"
        class="separacao"
        [class.active]="tab == 'separacao'"
      >
        <a>
          <span>{{ num_separacao }}</span>
          <strong>Enviado Laboratório</strong>
        </a>
      </li>
      <li
        (click)="changeTab('separado')"
        class="separacao"
        [class.active]="tab == 'separado'"
      >
        <a>
          <span>{{ num_separado }}</span>
          <strong>Pronto para Entrega</strong>
        </a>
      </li>
      <li
        (click)="changeTab('parcial')"
        class="parcial"
        [class.active]="tab == 'parcial'"
      >
        <a>
          <span>{{ num_parcial }}</span>
          <strong>Entrega Parcial</strong>
        </a>
      </li>

      <li
        (click)="changeTab('entrega')"
        class="entrega"
        [class.active]="tab == 'entrega'"
      >
        <a>
          <span>{{ num_entrega }}</span>
          <strong>Entrega</strong>
        </a>
      </li>
      <li
        (click)="changeTab('cancelado')"
        class="cancelado"
        [class.active]="tab == 'cancelado'"
      >
        <a>
          <span>{{ num_cancelado }}</span>
          <strong>Cancelados</strong>
        </a>
      </li>
    </ul>
    <div class="orders">
      <div
        *ngFor="let order of orders.orders; let i = index"
        (click)="openDetail(order, i)"
        [class.active]="order.idpedido == openid"
        [class.complete]="order.idpedido_situacao == 8"
        [class.pendente]="order.tab == 'pendente'"
        [class.separacao]="
          order.tab == 'separacao' ||
          order.tab == 'separado' ||
          order.tab == 'rota_entrega'
        "
        [class.cancelado]="order.tab == 'cancelado'"
        [class.entrega]="order.tab == 'entrega'"
      >
        <strong>N.º {{ order.idpedido }}</strong>
        <div class="atraso">
          <span *ngIf="order.data_agendamento">
            <span
              *ngIf="order.situacao_atraso == 'A'"
              class="tag-atrasado"
              title="Pedido atrasado"
            ></span>
            <span
              *ngIf="order.situacao_atraso == 'P'"
              class="tag-provavel-atraso"
              title="Provável atraso"
            ></span>
            <span
              *ngIf="order.situacao_atraso == 'N'"
              class="tag-sem-atraso"
              title="Sem atraso"
            ></span>
          </span>
        </div>
        <div class="name">
          <span>{{ order.nome }}</span>
        </div>
        <span class="info">
          <b
            *ngIf="order.data_agendamento && order.idpedido_situacao != 8"
            class="scheduled"
            >Agendado
            {{ order.data_agendamento.replace(" ", "T") | date: "dd/MM" }}
            {{ order.data_agendamento.replace(" ", "T") | date: "H:mm" }} -
            {{ order.hora_final_agendamento }}
          </b>
          <b *ngIf="order.idpedido_situacao == 8" class="finish">Concluído</b>
        </span>
        <figure>
          <i
            *ngIf="order.entrega == 'S'"
            class="ic ic-moto"
            [class.on-route]="order.idpedido_situacao == 7"
          ></i>
          <i *ngIf="order.entrega == 'N'" class="ic ic-build"></i>
        </figure>
        <span class="price">R$ {{ order.total | number: ".2" }}</span>
        <span class="payment">
          
          <b *ngIf="order.total != order.valor_pago" class="online tred">Pagar na entrega</b>

          <b *ngIf="order.pagamento == 'C'" class="online">Stone - Crédito</b>
          <b *ngIf="order.pagamento == 'X'" class="online">Stone -Crédito</b>
          <b *ngIf="order.pagamento == 'D'" class="online">Stone -Débito</b>
          <b *ngIf="order.pagamento == 'P'" class="online">Stone - PIX</b>
          <b *ngIf="order.pagamento == 'I'" class="online">Dinheiro</b>
          <b *ngIf="order.pagamento == 'G'" class="online">Garantia</b>   
          <b *ngIf="order.pagamento == 'O'" class="online">Outros</b>
          <b *ngIf="order.pagamento == 'B'" class="online">Banricompras</b> 
          <b *ngIf="order.pagamento == 'R'" class="online">Cortesia</b>
          <b *ngIf="order.pagamento == 'V'" class="online">PagSeguro</b>           
        </span>
        <span class="time">
          <b class="delay dnone">Atrasado 2 dias</b>
          <b *ngIf="hasFilial">{{ order.estabelecimento_nome }}</b>
        </span>
      </div>
      <div class="orders-loading" *ngIf="loadingOrder && !loading">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-loading" *ngIf="loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </section>
  <aside id="detailOrder" class="detail">
    <header>
      <figure>
        <i class="ic ic-clock"></i>
      </figure>
      <span *ngIf="order.data"
        >{{ getDay(order.data.replace(" ", "T") | date: "d/MM/y") }} às
        {{ order.data.replace(" ", "T") | date: "H:mm" }}</span
      >
      <b
        *ngIf="order.data_agendamento && order.situacao_atraso == 'A'"
        class="tag-atrasado"
        >Atrasado</b
      >
      <b
        *ngIf="order.data_agendamento && order.situacao_atraso == 'P'"
        class="tag-provavel-atraso"
        >Provável atraso</b
      >
      <b
        *ngIf="order.data_agendamento && order.situacao_atraso == 'N'"
        class="tag-sem-atraso"
        >Sem atraso</b
      >

      <a (click)="closeDetail()" class="btn-close"></a>
      <div
        class="btn-option"
        (click)="toggleOptions()"
        (mouseout)="hideOptions()"
        [class.open]="optionOpen"
      >
        <i></i>
        <i></i>
        <i></i>
        <div (mouseover)="clearOptions()" (mouseout)="hideOptions()">
          <a *ngIf="isAdmin" (click)="onShowChangeStatus()">Mudar situação</a>
          <a
            *ngIf="
              isAdmin &&
              (order.idpedido_situacao < 5 || order.idpedido_situacao == 9)
            "
            (click)="onShowSchedule()"
            >Mudar agendamento</a
          >
          <a (click)="gerarPDF()">Imprimir <i class="ic ic-print"></i></a>
          <a (click)="gerarViaLab()">Gerar via Laboratório </a>
          <a (click)="gerarNota()">Nota Fiscal</a>
          <a *ngIf="isAdmin" (click)="onShowAddPayment()">Adicionar Pagamento</a>
        </div>
      </div>
    </header>
    <strong>N.º {{ order.idpedido }}</strong>
    <ul class="linetime" *ngIf="order.idpedido_situacao != 10">
      <li class="active">
        <i></i>
        <span>Pendente</span>
      </li>
      <li
        [class.active]="
          order.tab == 'separacao' ||
          order.tab == 'separado' ||
          order.tab == 'rota_entrega' ||
          order.tab == 'entrega'
        "
      >
        <i></i>
        <span>Em andamento</span>
      </li>
      <li [class.active]="order.idpedido_situacao == 8">
        <i></i>
        <span>Concluído</span>
      </li>
    </ul>
    <div class="cancelado" *ngIf="order.idpedido_situacao == 10">
      <span>Pedido cancelado</span>
      <strong *ngIf="order.cancelado">{{ order.cancelado.descricao }}</strong>
    </div>
    <div
      class="cancelado"
      *ngIf="
        order.processing_failure &&
        !order.processing_parcial_failure &&
        !isTryAnotherCapture
      "
    >
      <span>Falha no processo de captura</span>
      <strong
        >Ocorreu um problema ao autorizar a compra, tente novamente.</strong
      >
      <button (click)="tryAnotherCapture()" class="btn btn-danger-outline">
        Realizar nova tentativa
      </button>
    </div>
    <div class="cancelado" *ngIf="isAntifraude">
      <span>Antifraude</span>
      <strong>{{ antifraude }}</strong>
      <button (click)="onManualRelease()" class="btn btn-danger-outline">
        Liberação manual
      </button>
    </div>
    <div class="cancelado" *ngIf="isNeedConfirmToRelease">
      <span>Confirmação do pedido!</span>
      <strong
        >Por favor, o pedido precisa de uma revisão nos valores dos produtos
        para poder finalizar a seleção.</strong
      >
      <button (click)="onConfirmRelease()" class="btn btn-danger-outline">
        Autorização manual
      </button>
    </div>

    <div class="cancelado" *ngIf="isTryAnotherCapture">
      <span>Atenção</span>
      <strong
        >Em breve uma nova tentativa de captura da compra será
        realizada.</strong
      >
    </div>
        <div class="cancelado">
        <span><strong>
        {{ order.obs }}</strong>
        </span>
    </div>
    <div class="info" (click)="openInfo = !openInfo" [class.open]="openInfo">
      <div class="personal">
        <figure>
          <span>{{ order.nome != "" ? order.nome[0] : "" }}</span>
        </figure>
        <span>
          <strong>{{ order.nome }}</strong>
          <span>
            <a _ngcontent-lqg-c218="" target="_blank" href="https://wa.me/55{{ order.telefone }}"><i _ngcontent-lqg-c218="" class="ic ic-whatsapp"></i></a>
            {{ order.telefone }}</span>
          <span>{{ order.email }}</span>
        </span>
      </div>
      <div *ngIf="order.cpf != '' && order.cpf != null" class="address">
        {{ (order.cpf + "").length == 14 ? "CPF" : "CNPJ" }}: {{ order.cpf }}
      </div>
      <div
        *ngIf="order.usuario_total_pedidos && order.usuario_total_pedidos > 0"
        class="address"
      >
        Total de pedidos: {{ order.usuario_total_pedidos }}
      </div>
      <div class="address">
        {{ order.logradouro }}, {{ order.numero }} {{ order.complemento }} -
        {{ order.bairro }}, {{ order.cidade }} - {{ order.uf }}, {{ order.cep }}
      </div>
      <div class="distance">
        <b>{{ formatDistance(order.distance) }}</b> de distância da
        <b>{{ order.nome_estabelecimento }}</b>
      </div>
    </div>

    
    <div
      class="lst"
      (click)="openProducts = !openProducts"
      [class.open]="openProducts"
    >
      <div>
        <span>Itens do pedido </span>
        <b>{{ order.products ? order.num_produtos : 0 }}</b>
      </div>
      <ul>
        <li *ngFor="let product of order.products; let i = index">
          <div
            *ngFor="
              let emfalta of order.emfalta
                | filter: product.idproduto_geral:'for_idproduto_geral';
              let j = index
            "
            class="emfalta"
          >
            <span>{{ emfalta.descricao }}</span>
            <span class="rtext"><i></i>Em falta</span>
          </div>
          <div
            [class.emfalta]="product.isfree || product.removido == 'S'"
            [class.add]="onCheckAdds(product)"
          >
            <span *ngIf="product.unid_venda != 'Kg'">{{
              product.descricao
            }}</span>
            <span *ngIf="product.unid_venda == 'Kg'"
              >{{ product.descricao }} ({{ product.quantidade }})</span
            >
            <span
              *ngIf="
                !product.isfree &&
                product.removido == 'N' &&
                product.unid_venda != 'Kg'
              "
              class="rtext"
              >{{ product.quantidade }} x R$
              {{ product.preco | number: ".2" }}</span
            >
            <span
              *ngIf="
                !product.isfree &&
                product.removido == 'N' &&
                product.unid_venda == 'Kg'
              "
              class="rtext"
              >{{ product.peso_qtd }} Kg x R$
              {{ product.peso_preco | number: ".2" }} Kg</span
            >
            <span *ngIf="product.isfree" class="rtext"><i></i>Grátis</span>
            <span *ngIf="product.removido == 'S'" class="rtext"
              ><i></i>Removido</span
            >
          </div>
        </li>
      </ul>
      <div class="download dnone">
        <button>Visualizar PDF do pedido completo</button>
      </div>
    </div>
     
    <ul class="subtotal">
      <li>
        <b>Subtotal dos itens</b>
        <b class="rtext">R$ {{ order.subtotal | number: ".2" }}</b>
      </li>
      <li *ngIf="order.cupom_codigo">
        <span
          >Cupom: <b>{{ order.cupom_codigo }}</b></span
        >
        <span></span>
      </li>
      <li>
        <span>Desconto</span>
        <span class="rtext tred"
          >- R$
          {{
            (order.desconto == null ? 0 : order.desconto) | number: ".2"
          }}</span
        >
      </li>
      <li>
        <span>Valor Pago</span>
        <span class="rtext"
          >R$ {{ (order.valor_pago == null ? 0 : order.valor_pago) | number: ".2" }}</span
        >
      </li>
      <li>
        <span *ngIf="order.entrega == 'S'">Frete</span>
        <span *ngIf="order.frete > 0" class="rtext"
          >R$ {{ order.frete | number: ".2" }}</span
        >
      </li>
      <li *ngIf="order.juros != null && order.juros > 0">
        <span>Juros parcelamento</span>
        <span class="rtext">R$ {{ order.juros | number: ".2" }}</span>
      </li>
      <li>
        <b>Total do pedido</b>
        <b class="rtext">R$ {{ order.total | number: ".2" }}</b>
      </li>
      <li>
        <b>A PAGAR</b>
        <b class="rtext tred">
          R$ {{ (order.valor_pago == null ? 0 : (order.total-order.valor_pago)) | number: ".2" }}
        </b>
      </li>

    </ul>

    <ul
      *ngIf="order.promotions && order.promotions.length > 0"
      class="list-itens"
    >
      <li>
        <b>Promoções</b>
      </li>
      <li *ngFor="let promocao of order.promotions; let i = index">
        <span>{{ promocao.descricao }}</span>
        <span class="rtext"></span>
      </li>
    </ul>

    <ul *ngIf="order.idoperador_empacotador" class="list-itens">
      <li>
        <b>Dados do Vendedor</b>
      </li>
      <li>
        <span>Vendedor</span>
        <span class="rtext">{{ order.separador_nome }}</span>
      </li>
      <li *ngIf="order.data_inicio_separacao">
        <span>Inicio</span>
        <span class="rtext">{{
          order.data_inicio_separacao.replace(" ", "T") | date: "H:mm"
        }}</span>
      </li>
      <li *ngIf="order.pedido_tempo_separacao">
        <span>Duração</span>
        <span class="rtext">{{
          formatDuration(order.pedido_tempo_separacao)
        }}</span>
      </li>
    </ul>

    


    <div class="delivery">
      <figure>
        <i
          *ngIf="order.entrega == 'S'"
          class="ic ic-moto"
          [class.on-route]="order.idpedido_situacao == 7"
        ></i>
        <i *ngIf="order.entrega == 'N'" class="ic ic-build"></i>
      </figure>

      <b *ngIf="order.pagamento == 'A'" class="online">Pagar na entrega</b>
      <b *ngIf="order.pagamento == 'C'" class="online">Crédito a vista</b>
      <b *ngIf="order.pagamento == 'X'" class="online">Crédito Parcelado</b>
      <b *ngIf="order.pagamento == 'D'" class="online">Débito</b>
      <b *ngIf="order.pagamento == 'P'" class="online">PIX</b>
      <b *ngIf="order.pagamento == 'I'" class="online">Dinheiro</b>


    </div>

    <span *ngIf="order.cartao && order.cartao.tipo == 'D'" class="payment"
      >{{ order.cartao.descricao }} débito</span
    >
    <span *ngIf="order.cartao && order.cartao.tipo == 'C'" class="payment"
      >{{ order.cartao.descricao }} crédito</span
    >
    <span *ngIf="order.cartao && order.cartao.tipo == 'V'" class="payment"
      >Voucher {{ order.cartao.descricao }}</span
    >
    <span
      *ngIf="(order.cartao && order.cartao.tipo == 'M') || order.idcartao == 0"
      class="payment"
      >Em dinheiro</span
    >
    <span *ngIf="order.cartao && order.cartao.tipo == 'A'" class="payment"
      >Aplicativo {{ order.cartao.descricao }}</span
    >

    <ul
      *ngIf="order.transacoes && order.transacoes.length > 0"
      class="list-itens mt20"
    >
      <li>
        <b
          >Dados de
          {{ order.transacoes.length > 1 ? "transações" : "transação" }}</b
        >
      </li>
      <li *ngFor="let transacao of order.transacoes; let i = index" class="lst">
        <ul>
          <li>
            <span>Transação ID</span>
            <span class="rtext">{{ transacao.id }}</span>
          </li>
          <li>
            <span>NSU</span>
            <span class="rtext">{{ transacao.number }}</span>
          </li>
          <li>
            <span>Data</span>
            <span *ngIf="transacao.data" class="rtext"
              >{{ transacao.data.replace(" ", "T") | date: "d/MM/y" }} às
              {{ transacao.data.replace(" ", "T") | date: "H:mm" }}</span
            >
          </li>
          <li *ngIf="transacao.installments > 1">
            <span>Parcelas</span>
            <span class="rtext"
              >{{ transacao.installments }}x R$
              {{ transacao.valor_parcela | number: ".2" }}</span
            >
          </li>
          <li>
            <span>Valor</span>
            <span class="rtext">R$ {{ transacao.valor | number: ".2" }}</span>
          </li>
          <li *ngIf="transacao.payment_id">
            <span>Pagamento ID</span>
            <span class="rtext">{{ transacao.payment_id }}</span>
          </li>
          <li *ngIf="transacao.emissor_code">
            <span>Código do Emissor</span>
            <span class="rtext">{{ transacao.emissor_code }}</span>
          </li>
          <li *ngIf="transacao.ds_antifraude">
            <span>Antifraude</span>
            <span class="rtext">{{ transacao.ds_antifraude }}</span>
          </li>
        </ul>
      </li>
    </ul>

    <div class="loading" *ngIf="loadingDetail">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </aside>
</div>
<div
  #searchFilter
  class="search-filter search-filter-order"
  [class.visible]="showFilter"
>
  <form [formGroup]="filterFrm" (ngSubmit)="onSubmitFilter()" novalidate>
    <div class="item">
      <strong>Data</strong>
      <div class="norow">
        <div>
          <div class="tipo-data">
            <ng-select
              placeholder="Selecione..."
              [clearable]="false"
              formControlName="tipo_data"
              [items]="listDatas"
              bindLabel="label"
              bindValue="id"
            ></ng-select>
          </div>
        </div>
        <div>
          <mat-form-field appearance="standard" class="dtRange">
            <mat-label>Data inicial</mat-label>
            <input
              matInput
              formControlName="dt_start"
              [matDatepicker]="pickerDtStart"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerDtStart"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerDtStart></mat-datepicker>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="standard" class="dtRange">
            <mat-label>Data final</mat-label>
            <input
              matInput
              formControlName="dt_end"
              [min]="dt_start.value"
              [matDatepicker]="pickerDtEnd"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerDtEnd"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerDtEnd></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="item">
      <strong>Entregas</strong>
      <div class="jc-start">
        <mat-checkbox formControlName="entrega_nodia" class="mr10"
          >Entregues no dia</mat-checkbox
        >
        <mat-checkbox formControlName="pendente_nodia" class="mr10"
          >Pendentes no dia</mat-checkbox
        >
      </div>
    </div>
    <div class="item">
      <strong>Atrasos</strong>
      <div class="jc-start">
        <mat-checkbox formControlName="atraso_sem" class="mr10"
          >Sem atrasos</mat-checkbox
        >
        <mat-checkbox formControlName="atraso_provavel" class="mr10"
          >Provável atraso</mat-checkbox
        >
        <mat-checkbox formControlName="atraso_atrasado" class="mr10"
          >Atrasado</mat-checkbox
        >
      </div>
    </div>
    <div *ngIf="hasFilial" class="item">
      <strong>Filial</strong>
      <div>
        <ng-select
          placeholder="Selecione..."
          formControlName="idestabelecimento"
          [items]="listStores"
          bindLabel="nome"
          bindValue="idestabelecimento"
        ></ng-select>
      </div>
    </div>
    <footer>
      <button (click)="onClearFilter()" type="button" class="btn btn-link">
        Limpar filtros
      </button>
      <button (click)="onSubmitFilter()" type="button" class="btn btn-primary">
        Aplicar filtro
      </button>
    </footer>
  </form>
</div>

<div
  *ngIf="isExportLoading"
  class="modal"
  [class.open]="modalExportOpen || isPrintLoading"
>
  <div class="modal-content modal-medium modal-export">
    <h3 *ngIf="!isPrintLoading">Exportando...</h3>
    <h3 *ngIf="isPrintLoading">Gerando...</h3>
    <div class="tab-loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isShowModal" class="modal" [class.open]="showModal">
  <div *ngIf="showTransfer" class="modal-content modal-medium modal-transfer">
    <h3>Transferir pedido de estabelecimento</h3>
    <div>
      <span
        >Do <strong>{{ order.nome_estabelecimento }}</strong> para:</span
      >
      <ng-select
        [items]="listStores"
        bindLabel="nome"
        bindValue="idestabelecimento"
        placeholder="Selecione o estabelecimento..."
        [(ngModel)]="idEstabelecimentoTransfer"
      ></ng-select>
    </div>
    <footer>
      <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Cancelar
      </button>
      <button (click)="onTransfer()" type="button" class="btn btn-primary">
        Transferir
      </button>
    </footer>
  </div>

  <div
    *ngIf="showChangeStatus"
    class="modal-content modal-medium modal-change-status"
  >
    <h3>Mudar situação do pedido</h3>
    <div>
      <span
        >De <strong>{{ order.ds_pedido_situacao }}</strong> para:</span
      >
      <ng-select
        [items]="listOrderSituationSelect"
        bindLabel="descricao"
        bindValue="idpedido_situacao"
        placeholder="Seleciona a situação..."
        [(ngModel)]="idpedidoSituacaoChange"
      ></ng-select>
    </div>
    <footer>
      <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Cancelar
      </button>
      <button (click)="onChangeStatus()" type="button" class="btn btn-primary">
        Mudar situação
      </button>
    </footer>
  </div>

  <div
    *ngIf="showAddPayment"
    class="modal-content modal-medium modal-addpayment"
  >
   
        <h3>Adicionar Pagamento </h3>
  
    <div>
      <iframe width="100%" height="280" scrolling="no" [src]=urlPayment>

      </iframe>  
            
    </div>
    <footer>
          <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Fechar
      </button>
    </footer>
  </div>
  <div
    *ngIf="showChangeSchedule"
    class="modal-content modal-medium modal-change-schedule"
  >
    <h3>Mudar o agendamento do pedido</h3>
    <div>
      <div>
        <label>Data do agendamento</label>
        <div class="frm-datepicker">
          <input
            type="text"
            [(ngModel)]="agendamento_data"
            [min]="startDate"
            class="form-control"
            [matDatepicker]="pickerScheduleDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="pickerScheduleDate"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #pickerScheduleDate
            [startAt]="startDate"
          ></mat-datepicker>
        </div>
      </div>
      <div>
        <div>
          <label>Hora do agendamento</label>
          <div class="prelative">
            <input
              type="text"
              class="form-mat-input-element"
              [(ngModel)]="agendamento_hora"
              matInput
              mask="Hh:m0"
              [dropSpecialCharacters]="false"
              placeholder="00:00"
            />
            <i class="ic ic-clock-gray"></i>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Cancelar
      </button>
      <button
        (click)="onChangeSchedule()"
        type="button"
        class="btn btn-primary"
      >
        Mudar agendamento
      </button>
    </footer>
  </div>

  <div
    *ngIf="showChangeDelivery"
    class="modal-content modal-medium modal-change-delivery prelative"
  >
    <h3>Mudar a forma de entrega para Delivery</h3>
    <div *ngIf="stepChangeDelivery == 1">
      <div>
        <label class="title"
          >Realizar a entrega do pedido no endereço do cliente:</label
        >
      </div>
      <div>
        <div class="address">
          <span
            >{{ objAddressDelivery.logradouro }},
            {{ objAddressDelivery.numero }}
            {{ objAddressDelivery.complemento }} -
            {{ objAddressDelivery.bairro }}, {{ objAddressDelivery.cidade }} -
            {{ objAddressDelivery.uf }}, {{ objAddressDelivery.cep }}</span
          >
          <a (click)="changeAddressDelivery()">Alterar</a>
        </div>
      </div>
      <div *ngIf="makeDelivery">
        <label>Valor do frete</label>
        <div class="frete">
          <span>R$</span>
          <input
            type="text"
            [(ngModel)]="valorFrete"
            currencyMask
            class="form-control"
          />
        </div>
      </div>
      <div *ngIf="!makeDelivery">
        <label class="error"
          >Endereço do cliente fora da área de entrega!</label
        >
      </div>
    </div>
    <div *ngIf="stepChangeDelivery == 2" class="list">
      <div class="h">
        <label class="title"
          >Selecione o endereço do cliente para realizar a entrega:</label
        >
      </div>
      <div>
        <div
          *ngFor="let add of listCustomerAddress; let i = index"
          (click)="selectAddressDelivery(add)"
          class="address address-hover"
        >
          <span
            >{{ add.logradouro }}, {{ add.numero }} {{ add.complemento }} -
            {{ add.bairro }}, {{ add.cidade }} - {{ add.uf }},
            {{ add.cep }}</span
          >
        </div>
      </div>
    </div>
    <div *ngIf="stepChangeDelivery == 3" class="list">
      <div class="h">
        <label class="title">Cadastre novo endereço para entrega:</label>
      </div>
      <div *ngIf="objAddressDelivery.cidade == null" class="cep-address">
        <label>CEP</label>
        <div>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="objAddressDelivery.cep"
            (keyup)="onCEPChange()"
            mask="00000-000"
            placeholder="00000-000"
          />
        </div>
      </div>
      <div *ngIf="objAddressDelivery.cidade != null" class="frm-address">
        <div class="col-1">
          <label>Logradouro</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.logradouro"
            class="form-control"
            (keyup)="onChangeAddress()"
          />
        </div>
      </div>
      <div *ngIf="objAddressDelivery.cidade != null" class="frm-address">
        <div class="col-2">
          <label>Número</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.numero"
            class="form-control"
            (keyup)="onChangeAddress()"
          />
        </div>
        <div class="col-3">
          <label>Complemento</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.complemento"
            class="form-control"
            (keyup)="onChangeAddress()"
          />
        </div>
      </div>
      <div *ngIf="objAddressDelivery.cidade != null" class="frm-address">
        <div class="col-2">
          <label>Bairro</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.bairro"
            class="form-control"
            (keyup)="onChangeAddress()"
          />
        </div>
        <div class="col-2">
          <label>Cidade</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.cidade"
            class="form-control"
            [attr.disabled]="'disabled'"
          />
        </div>
        <div class="col-1">
          <label>Estado</label>
          <input
            type="text"
            [(ngModel)]="objAddressDelivery.uf"
            class="form-control"
            [attr.disabled]="'disabled'"
          />
        </div>
      </div>
    </div>
    <footer>
      <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Cancelar
      </button>
      <button
        *ngIf="stepChangeDelivery == 1"
        (click)="onChangeDelivery()"
        [attr.disabled]="!makeDelivery ? true : null"
        type="button"
        class="btn btn-primary"
      >
        Mudar forma de entrega
      </button>

      <button
        *ngIf="stepChangeDelivery == 2"
        (click)="addAddressCustomer()"
        type="button"
        class="btn btn-primary"
      >
        Novo endereço
      </button>
      <button
        *ngIf="stepChangeDelivery == 3"
        (click)="saveAddressCustomer()"
        [attr.disabled]="!addressOk ? true : null"
        type="button"
        class="btn btn-primary"
      >
        Salvar endereço
      </button>
    </footer>

    <div *ngIf="loadingDelivery" class="tab-loading">
      <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="showAddCupom"
    class="modal-content modal-medium modal-change-status modal-add-cupom"
  >
    <h3>Adicionar cupom ao pedido</h3>
    <div class="filter">
      <span>Filtrar pelo código do cupom: </span>
      <div class="dflex frow">
        <input
          type="text"
          (keyup.enter)="findCupons()"
          [(ngModel)]="ipt_cupom"
          class="form-control mr5"
        />
        <button
          (click)="findCupons()"
          type="button"
          class="btn btn-primary mr5"
        >
          Filtrar
        </button>
        <button
          (click)="ipt_cupom = ''; findCupons()"
          type="button"
          class="btn btn-cancel"
        >
          Limpar
        </button>
      </div>
    </div>
    <div>
      <span>Código do cupom: </span>
      <ng-select
        [items]="listCupons"
        bindLabel="codigo"
        bindValue="codigo"
        [placeholder]="lbl_list_cupons"
        [(ngModel)]="codigo_cupom"
        [clearable]="false"
      ></ng-select>
    </div>
    <footer>
      <button (click)="closeModal()" type="button" class="btn btn-cancel">
        Cancelar
      </button>
      <button
        (click)="onAddCupom()"
        [disabled]="codigo_cupom == null"
        type="button"
        class="btn btn-primary"
        [class.disabled]="codigo_cupom == null"
      >
        Adicionar
      </button>
    </footer>
  </div>
</div>
